<template>
  <div>


    <div class="row">

      <div class="unpaid-payments-action-buttons">
        <div
            class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
            @click="exportToCsv()"
        >
          <i class="fas fa-file-excel"/>
          Eksportuj do CSV
        </div>


      </div>

    </div>


    <div :class="generatorMainSectionClass">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>
      <div v-show="paymentsChecked.length > 0" class="col unpaid-payments-checked-items">
        <div>
          {{ paymentsChecked.length }} zaznaczonych dokumentów do opłacenia na kwotę: {{ getAmountToPay() }}
          PLN <b @click="resetCheckedItems();refreshPaymentsData()" style="cursor:pointer;"> [Wyczyść zaznaczone]</b>
        </div>
      </div>
        <CommonTableFilterSection2 :filters-fetch-method="paymentsModule.httpGetPaymentsAvailableFilters"
                                  :explicit-filters="filtersForCurrentView"
                                  @onSelectedFilters="updateFilters($event)"
        />




      <div class="unpaid-payments-stage">

        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="paymentsModule.getPaymentsTotal"
              :totalPages="paymentsModule.getPaymentsPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :initiallyCheckedItemsData="paymentsChecked"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :enableRowSelection="false"

          />
        </div>

      </div>


    </div>
  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";
import {addReportFormFields} from "@/views/ReportsManager/data/addReportFormFields";


import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {paymentsHelperMethods} from "./helper/paymentsHelperMethods";
import {log} from "@/state/pinia/log";
import CommonTableFilterSection2 from "@/components/widgets/CommonTableFilterSection2.vue";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useLayoutStore} from "@/state/pinia/layout";

export default {
  name: "UnpaidPaymentsStage",
  props: {
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },

  },
  components: {
    CommonTableFilterSection2,

    // BModal,
    SearchBar2,
    // PaymentConfirmationModal,
    CommonTable2
  },
  data() {
    return {
      showPaymentsModalTitle: "Płatności dla dokumentu: ",
      rowIdentifierKey: "unique_global_doc_id",
      paymentsForItemsRowIdentifier: "id_dokumentu_plat",
      tableData: {},
      paymentsChecked: [],
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "termin_platnosci",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      paymentsRows: [],
      availableHeaders: [],
      availableFilters: [],
      tableMassActions: [
        {
          text: "Opłać zaznaczone",
          icon: "fas fa-dollar-sign",
          action: "pay-all",
          class: "btn btn-success mass-operations-btn",
          enabled: true,
        },
        {
          text: "Ukryj zaznaczone",
          icon: "fas fa-eye-slash",
          action: "ignore-all",
          class: "btn btn-danger mass-operations-btn",
          enabled: true,
        },
        {
          text: "Przywróć zaznaczone",
          icon: "fas fa-eye",
          action: "un-ignore-all",
          class: "btn btn-success mass-operations-btn",
          enabled: true,
        },
      ],
      rowActions: [],
      formRows: addReportFormFields,
      fieldsAvailableForSearch: [],
      paidStatus: "UNPAID",
      paymentsListForItemTableData: {},
      refreshTable: true, //added key to force re-rendering,
      selectedFilters: [],
      allCheckedItemsOnAllPages: [],
      checkedItemsPayValueOnPages: 0.0,
      checkedPaymentsOnPages: {},
      filtersForCurrentView: ["nip_apteki", "id_apteki", "nazwa_apteki", "nip", "nazwa_dostawcy", "termin_platnosci", "czy_widoczny", "wartosc_brutto", "wartosc_pozycji_brutto","typ_platnosci_dok"],
    };
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },

    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row payments-table-container';
      } else {
        return 'payments-table-container';
      }
    },
  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.currentPage = 1;
      this.refreshPaymentsData();
    },
    runAction(event) {
      log.log("run action trigerred:");
      log.log(event);
      if (event.action.action === "pay-selected") {
        this.payAll([event.itemData]);
      } else if (event.action.action === "view-payments") {
        paymentsHelperMethods.showPaymentsModal(event.itemData, this.paymentsForItemsRowIdentifier);
      } else if (event.action.action === "ignore-item") {
        paymentsHelperMethods.ignoreAll([event.itemData]).then(() => {
          this.refreshPaymentsData().then(() => {
            this.resetCheckedItems();
          });
        });
      } else if (event.action.action === "un-ignore-item") {
        paymentsHelperMethods.unIgnoreAll([event.itemData]).then(() => {
          this.refreshPaymentsData().then(() => {
            this.resetCheckedItems();
          });
        });
      }


    },
    runMassAction(event) {
      log.log(event);
      if (event.action.action === "pay-all") {
        this.payAll(this.paymentsChecked);
      } else if (event.action.action === "ignore-all") {
        paymentsHelperMethods.ignoreAll(this.paymentsChecked).then(() => {
          this.refreshPaymentsData().then(() => {
            this.resetCheckedItems();
          });
        });
      } else if (event.action.action === "un-ignore-all") {
        paymentsHelperMethods.unIgnoreAll(this.paymentsChecked).then(() => {
          this.refreshPaymentsData().then(() => {
            this.resetCheckedItems();
          });
        });
      }

    },
    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshPaymentsData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    saveGlobalCheckedItems(event) {
      log.log("event", event);
      this.paymentsChecked = event.itemsData;
      this.checkedItemsPayValueOnPages = this.paymentsChecked.map(item => item["wartosc_brutto"]).reduce((a, b) => a + b, 0);

    },
    resetCheckedItems() {
      this.checkedItemsPayValueOnPages = 0.0;
      this.paymentsChecked = [];
    },
    checkAction(event) {
      log.log("Checked action:", event.items);
      this.saveGlobalCheckedItems(event);
    },
    refreshPaymentsData(showLazyLoader = true) {

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o płatnościach");
      this.paymentsRows = JSON.parse(JSON.stringify(this.paymentsModule.getPayments));

      return this.paymentsModule.httpGetPaymentHeaders().then(() => {
        this.availableHeaders = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentsHeaders));
        this.refreshPaymentsList(showLazyLoader);
      });
    },
    refreshFieldsAvailableForSearch() {
      this.fieldsAvailableForSearch = [];
      this.paymentsModule.httpGetPaymentSearchKeys().then(() => {
        var searchKeysFetched = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentsSearchKeys));
        log.log("searchKeysFetched:" + searchKeysFetched);

        var tableColumnsAvailableForSearch = this.availableHeaders.filter(header => searchKeysFetched.includes(header.key) && header.type === "text");

        for (var i = 0; i < tableColumnsAvailableForSearch.length; i++) {
          this.fieldsAvailableForSearch.push({
            name: this.paymentsModule.paymentsVisibleHeadersTitlesMap[tableColumnsAvailableForSearch[i].key],
            key: tableColumnsAvailableForSearch[i].key
          });
        }

      });
    },
    refreshPaymentsList(showLazyLoader = true) {
      if (showLazyLoader) {
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.lazyloaderModule.setProgressBarMessage("Pobieranie listy płatności");
      }

      this.paymentsModule.setPayments([])
      // this.currentTaskId = this.$route.params.taskId;


      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: this.selectedFilters
      }

      var payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
        paidStatus: this.paidStatus

      };
      this.refreshTable = false;
      this.paymentsModule.httpGetPaymentsDataPaging(payload).then(() => {
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.lazyloaderModule.setProgressBarMessage("Pobieranie listy płatności");
        this.paymentsRows = [];
        var payments = JSON.parse(JSON.stringify(this.paymentsModule.getPayments));
        for (var i = 0; i < payments.length; i++) {
          payments[i]["data_utworzenia"] = paymentsHelperMethods.formatDateToLocale(payments[i]["data_utworzenia"]);
          payments[i]["termin_platnosci"] = paymentsHelperMethods.formatDateToLocale(payments[i]["termin_platnosci"]);
          payments[i]["tooltip"] = this.commonModule.getDrugstoresNameMap[payments[i]["id_apteki"]];
          payments[i]["typ_platnosci_dok"] = payments[i]["typ_platnosci_dok"] === 3;

          if (payments[i]["wartosc_brutto"] === 0) {
            payments[i]["wartosc_brutto"] = payments[i]["wartosc_pozycji_brutto"]
          }

          // payments[i]["row-class"] = this.getRowClass(payments[i]);
          payments[i]["status"] = "fas fa-times"
          payments[i][this.rowIdentifierKey] = payments[i]["id_dokumentu"] + "#" + payments[i]["id_apteki"];
          var isVisible = payments[i]["czy_widoczny"];
          if (isVisible === "0" || isVisible === 0) {
            payments[i]["row-class"] = "row-disabled";
            payments[i]["row-style"] = "color:gray!important;";
            payments[i]["status"] = "fas fa-eye-slash";

          }else {
            payments[i]["row-class"] = "";
          }

          this.paymentsRows.push(payments[i]);
        }


        var paymentsHeaders = []
        for (var j = 0; j < this.paymentsModule.paymentsVisibleHeaders.length; j++) {
          var header = this.availableHeaders.find(header => header.key === this.paymentsModule.paymentsVisibleHeaders[j]);
          if (header !== undefined) {
            header["text"] = this.paymentsModule.paymentsVisibleHeadersTitlesMap[this.paymentsModule.paymentsVisibleHeaders[j]];
            if (header.key === "typ_platnosci_dok") {
              header.type = "boolean";
            }
            // setting type on id_dockumentu and id_apteki column to number style
            if (header.key === "id_dokumentu" || header.key === "id_apteki") {
              header["class"] = "sticky-header col-number";
            }

            if (header.key === "numer_dokumentu") {
              header["class"] = "col-mid-text";
            }
            if ( header.key === "nazwa_dostawcy") {
              header["style"] = "width:300px;text-align:left;padding-left:16px;padding-right:16px;";
            }

            paymentsHeaders.push(header);
          }
        }

        paymentsHeaders.push(
            {
              text: "St",
              key: "status",
              type: "icon",
              style: "cursor:pointer;width:20px;text-align:center",
              contentClass: "icon-center icon-warning",
              sortable: false,
              preventCopying: true
            },

            {
              text: "Akcje",
              key: "actions",
              type: "actions",

              sortable: false,
              preventCopying: true,
              actions: this.rowActions

            });


        // adding row actions
        for (var k = 0; k < this.paymentsRows.length; k++) {
          this.paymentsRows[k]["actions"] = [
            {
              text: "",
              icon: "fas fa-money-bill-wave",
              action: "view-payments",
              class: this.getShowPaymentsForDocumentActionClass(this.paymentsRows[k]),
              enabled: true,
              tooltip: "Zobacz płatności",
            },


            {
              text: "Opłać",
              icon: "fas fa-dollar-sign",
              action: "pay-selected",
              class: this.getPayRowDocumentActionClass(this.paymentsRows[k]),
              enabled: true,
              tooltip: "Oznacz wybrane dokumenty jako opłacone",
            },

            {
              text: "Ukryj",
              icon: "fas fa-eye-slash",
              action: "ignore-item",
              class: paymentsHelperMethods.getIgnoreDocumentActionClass(this.paymentsRows[k]),
              enabled: true,
              tooltip: "Zignoruj dokument",
            },
            {
              text: "Przywróć",
              icon: "fas fa-eye",
              action: "un-ignore-item",
              class: paymentsHelperMethods.getUnIgnoreDocumentActionClass(this.paymentsRows[k]),
              enabled: true,
              tooltip: "Przywróć dokument",
            }


          ];
        }


        this.tableData['headers'] = paymentsHeaders;

        this.refreshFieldsAvailableForSearch();
        this.tableData['massActions'] = this.tableMassActions;

        this.tableData['data'] = this.paymentsRows;
        this.refreshTable = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);
      });
    },


    getAmountToPay() {
      return this.checkedItemsPayValueOnPages.toFixed(2);
    },

    payAll(paymentsChecked) {
      paymentsHelperMethods.showPaymentConfirmModal(paymentsChecked, this.rowIdentifierKey).then((response) => {

        if ((response.isConfirmed && response.isConfirmed === true) || response.reloadList && response.reloadList === true) {
          this.refreshPaymentsData().then(() => {
            this.resetCheckedItems();
          });
        } else{
          //do nothing
        }
      });

    },


    getShowPaymentsForDocumentActionClass(row) {
      var paymentsSum = row["suma_platnosci"];
      if (paymentsSum == null || parseFloat(paymentsSum.toString) === 0.0) {
        return "element-not-visible";
      } else {
        return "btn btn-info table-actions-button edit-button";
      }
    },
    getPayRowDocumentActionClass(row) {
      var isVisible = row["czy_widoczny"];
      if (isVisible === "0" || isVisible === 0) {
        return "btn btn-secondary disabled table-actions-button edit-button";
      } else {
        return "btn btn-success table-actions-button edit-button";
      }
    },


    updateFilters(filters) {
      this.selectedFilters = filters;
      this.currentPage = 1;
      this.refreshPaymentsData(false);
    },

    exportToCsv() {
      paymentsHelperMethods.exportToFile(this.searchRequest, this.selectedFilters, this.currentPage, this.sortingDirection, this.sortingKey, this.paidStatus, "CSV")
    },


  },
  watch: {
    currentPage: {
      handler() {
        this.refreshPaymentsData();
      },
      deep: true,
    },

  },
  mounted() {

  },
  created() {
    // create cz_widoczny filter to show only visible documents at firtst fetch
    var beginFilter = {
      key: "czy_widoczny",
      selectedValues: ["1"],
    }
    this.selectedFilters.push(beginFilter);
    this.refreshPaymentsData();
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();

  },
};
</script>

<style scoped>
.payments-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.payments-table-container {
}

.unpaid-payments-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.unpaid-payments-checked-items {
  text-align: left;
  margin-left: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
  height: 24px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.unpaid-payments-stage {
  margin-top: 8px;
}


</style>
